import React, { FC } from "react";
import cn from "classnames";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { TextEditorView } from "src/components/TextEditor/TextEditorView";
import { Link } from "src/components/Link";
import { getImageUrl } from "src/utils/getImageUrl";
import { combineSlugId } from "src/utils/combineSlugId";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { IClone } from "src/@types/clones";
import { TopPopularCloneCardProperties } from "./TopPopularCloneCardProperties";
import { TopPopularCloneCardHeader } from "./TopPopularCloneCardHeader";

interface Props {
  className?: string;
  clone?: IClone;
}

export const TopPopularCloneCard: FC<Props> = ({ className, clone }) => {
  if (!clone) return null;

  const { id, company_name, slug, describe_product, main_photo } = clone || {};
  const combineSlug = combineSlugId(slug, id);

  return (
    <div
      className={cn(
        "flex flex-col items-center gap-5 lg:flex-row lg:items-start lg:gap-8 bg-purple-lighter rounded-20 p-5",
        className
      )}
    >
      <div className="flex flex-col lg:max-w-96 w-full">
        <div className="max-w-73.75 sm:max-w-96 w-full lg:h-44 rounded-20 overflow-hidden self-center">
          <Link
            className="flex h-full hover:scale-110"
            href={getItemPath(PATHNAMES.CLONE_ITEM, {
              slug: combineSlug,
            })}
          >
            <LazyLoadImage
              className="w-full h-full rounded-20 object-cover"
              src={getImageUrl(main_photo)}
              alt={company_name}
              effect="blur"
              wrapperProps={{
                style: { width: "100%" },
              }}
            />
          </Link>
        </div>
        <TopPopularCloneCardProperties {...clone} />
      </div>

      <div className="flex-1 w-full lg:pt-5 lg:pr-5">
        <TopPopularCloneCardHeader {...clone} />
        <hr className="h-px bg-gray-lighter border-0 my-5" />

        <TextEditorView
          viewType="text"
          className="break-all line-clamp-6 gl:line-clamp-7"
        >
          {describe_product}
        </TextEditorView>
      </div>
    </div>
  );
};
